import duration from 'dayjs/plugin/duration';

export default ({ app: { $dayjs } }) => {
  $dayjs.extend(duration);
};
